import React, { useContext, useMemo, useState } from 'react'
import styles from './EventsList.module.scss'
import EventCard from './EventCard/EventCard'
import { ReactComponent as LeftArrow } from '../../assets/media/icons/icon-arrow-left.svg'
import Spacer from '../Spacer/Spacer'
import SearchLocationContext from '../../context/SearchLocationContext'
import ApplicationContext from '../../context/ApplicationContext'
import { useEvents } from '../../hooks'

const EventsList = () => {
    const [applicationData] = useContext(ApplicationContext)
    const [localizations] = useState(applicationData.localizations)
    const { handleViewAllEventsClick } = useEvents()
    const [{ locationList, eventsListingActiveLocationId }] = useContext(SearchLocationContext)

    const eventsList = useMemo(() => {
        return locationList.find(location => location.locationId === eventsListingActiveLocationId)?.events
    }, [eventsListingActiveLocationId, locationList])

    return (
        <div className={`${styles.eventsListWrapper} ${eventsListingActiveLocationId ? styles.open : ''}`}>
            <div className={`${styles.container}`}>
                <div className={styles.header}>
                    <button className={styles.backButton} onClick={handleViewAllEventsClick} type='button' aria-label={localizations.backToFitterDetails}>
                        <LeftArrow aria-hidden='true' focusable='false' role='img' />
                        <h4 className={styles.header_text}>{localizations.backToFitterDetails}</h4>
                    </button>
                </div>
                <Spacer border={true} />
                <div className={styles.topBar}>
                    <div className={styles.topBar_heading}>
                        <span>{localizations.selectAnEvent}</span>
                    </div>
                </div>
                <div className={styles.content}>
                    {eventsList?.map(event => (
                        <EventCard key={event.id} event={event} localizations={localizations} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default EventsList
